import { Box, Flex } from 'reflexbox'
import React from 'react'
import SomethingWentOffscriptImg from '../images/something-went-offscript.jpg'

const ErrorBoundaryFallback = () => {
  return (
    <Flex flexWrap="wrap" justifyContent="center">
      <Box width={[1, 2 / 3, 1 / 3]} py={4}>
        <p>
          <h1 style={{ color: '#666666' }}>Shoot!</h1>
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          An unexpected error has occurred and we're working to fix the problem!
          <br />
          {/* eslint-disable-next-line react/no-unescaped-entities */}
          We'll be up and running shortly.
        </p>
        <img src={SomethingWentOffscriptImg} alt="Oops! Something went off-script!" />
      </Box>
    </Flex>
  )
}

export default ErrorBoundaryFallback
